import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Lottie from "lottie-react";
// import { faqs } from "./acceleratedCashbackData";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ctaImage from '../../pages/mystery-box/images/bg-top.png';
import Heading from '../../pages/mystery-box/images/top-heading.png';
import Unlock from '../../pages/mystery-box/images/unlock.png';
import Bg from '../../pages/mystery-box/images/state-bg.png';
import BgImage from '../../pages/mystery-box/images/bg.png';
import Bonus from '../../pages/mystery-box/images/bonus.png';
import Gradiant from '../../pages/mystery-box/images/Gradient.png';
import ReactHtmlParser from 'html-react-parser';
import Mystery from '../../pages/mystery-box/images/image.png';
import Line from '../../pages/mystery-box/images/Line.png';
import BgtopImage from '../../pages/mystery-box/images/bgimage.png';
import Cta from '../../pages/mystery-box/images/CTA.png';
import Earn from '../../pages/mystery-box/images/earn.png';
import AJio from '../../pages/mystery-box/images/AJio.png';
import Flipkart from '../../pages/mystery-box/images/Flipkart.png';
import Myntra from '../../pages/mystery-box/images/Myntra.png';
import MamaEarth from '../../pages/mystery-box/images/MMEARTH.png';
import XYXX from '../../pages/mystery-box/images/XYXX.png';
import Shopsy from '../../pages/mystery-box/images/Shopsy.png';
import Amazon from '../../pages/mystery-box/images/amazon.png';
import Truemeds from '../../pages/mystery-box/images/Truemeds.png';
import Strch from '../../pages/mystery-box-jan/images/strch.png';
import Fitspire from '../../pages/mystery-box-jan/images/fitspire.png';
import Kopara from '../../pages/mystery-box-jan/images/kopara.png';
import Derma from '../../pages/mystery-box/images/Derma.png';
import Arrow from '../../pages/mystery-box/images/arrow.png';
import Bellavita from '../../pages/mystery-box-jan/images/bellavitta.png';
import { useNavigate } from 'react-router-dom';
import dor from './images/dor.png'
import Foxtale from './images/foxtale.png'
import Boat from './images/boat.png'
import Puer from './images/puer.png'
import Levis from './images/levis.png'
import Booking from './images/booking.png'
import spencer from './images/spencer.png'
import bellavita from './images/bellavita.png'
import Faq from "./component/faq";
import MysteryLogo from "./images/Mystery logo.json";





const deals = [
  {
    name: "Reliance Digital",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/reliance-digital.png",
    link: 'cashkaro://stores/reliancedigital-coupons-excl-offr-mar26',
    cashback:'Upto 3% Cashback',
    bonus:'Flat ₹210 Bonus',
  },
  {
    name: "SSBeauty",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/ss-beauty.png",
    link: 'cashkaro://stores/ssbeauty-coupons-excl-offr-mar26',
    cashback:'Flat 18% Cashback',
    bonus:'Flat ₹140 Bonus',
  },
  {
    name: "Agoda",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/agoda.png",
    link: 'cashkaro://stores/agoda-excl-offr-mar26',
    cashback:'Flat 3.5% Cashback',
    bonus:'Flat ₹105 Bonus',
  },
  {
    name: "Croma",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/croma.png",
    link: 'cashkaro://stores/croma-excl-offr-mar26',
    cashback:'Upto 3% Cashback',
    bonus:'Flat ₹ 90 Bonus',
  },
  {
    name: "Muscleblaze",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/muscle-blaze.png",
    link: 'cashkaro://stores/muscleblaze-coupon-codes-excl-offr-mar26',
    cashback:'Flat 10% Cashback',
    bonus:'Flat ₹80 Bonus',
  },
  {
    name: "Shyaway",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/shyway.png",
    link: 'cashkaro://stores/shyaway-coupons-excl-offr-mar26',
    cashback:'Flat 25% Cashback',
    bonus:'Flat ₹75 Bonus',

  },
  {
    name: "Jivisa",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/jivisa.png",
    link: 'cashkaro://stores/jivisa-offers-excl-offr-mar26',
    cashback:'Flat 65% Cashback',
    bonus:'Flat ₹65 Bonus',

  },
  {
    name: "Koparo Clean",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/koparo.png",
    link: 'cashkaro://stores/koparoclean-coupons-excl-offr-mar26',
    cashback:'Flat 40% Cashback',
    bonus:'Flat ₹60 Bonus',

  },
  {
    name: "Hyugalife",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/hyugalife.png",
    link: 'cashkaro://stores/hyugalife-coupons-excl-offr-mar26',
    cashback:'Upto 10% Cashback',
    bonus:'Flat ₹55 Bonus',

  },
  {
    name: "Nykaa",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/nykaa.png",
    link: 'cashkaro://stores/nykaa-excl-offr-mar26',
    cashback:'Upto 6% Cashback',
    bonus:'Flat ₹50 Bonus',

  },
  {
    name: "Expedia",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/expedia.png",
    link: 'cashkaro://stores/expedia-flightbookings-excl-offr-mar26',
    cashback:'Upto 3% Cashback',
    bonus:'Flat ₹50 Bonus',

  },
  // {
  //   name: "Bewakoof.com",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/bewakoof.png",
  //   link: 'cashkaro://stores/bewakoof-excl-offr-mar26',
  //   cashback:'Flat 18% Cashback',
  //   bonus:'Flat ₹45 Bonus',

  // },
  {
    name: "OTT Play",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/ott.png",
    link: 'cashkaro://stores/ottplay-super-play-coupons-excl-offr-mar26',
    cashback:'Flat ₹149 Cashback',
    bonus:'Flat ₹40 Bonus',

  },
  {
    name: "Libas",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/libas.png",
    link: 'cashkaro://stores/libas-coupons-excl-offr-mar26',
    cashback:'Flat 7% Cashback',
    bonus:'Flat ₹40 Bonus',

  },
  {
    name: "Nutrabay",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/nutrabay.png",
    link: 'cashkaro://stores/nutrabay-coupon-codes-excl-offr-mar26',
    cashback:'Upto 10% Cashback',
    bonus:'Flat ₹35 Bonus',

  },
  {
    name: "Clove Oral Care",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/cclove.png",
    link: 'cashkaro://stores/clove-oral-care-coupons-excl-offr-mar26',
    cashback:'Upto 75% Cashback',
    bonus:'Flat ₹30 Bonus',

  },
  // {
  //   name: "Bajaj Prime",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/prime.png",
  //   link: 'cashkaro://stores/bajaj-prime-coupons-excl-offr-mar26',
  //   cashback:'Flat ₹625 Cashback',
  //   bonus:'Flat ₹30 Bonus',

  // },
  {
    name: "Zandu Care",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/zanduu.png",
    link: 'cashkaro://stores/zanducare-coupons-excl-offr-mar26',
    cashback:'Flat 18% Cashback',
    bonus:'Flat ₹30 Bonus',

  },
  {
    name: "The Derma Co",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/derma-co.png",
    link: 'cashkaro://stores/thedermaco-coupons-excl-offr-mar26',
    cashback:'Upto 20% Cashback',
    bonus:'Flat ₹25 Bonus',

  },
  {
    name: "Cleevo",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/cleevoo.png",
    link: 'cashkaro://stores/cleevo-offers-excl-offr-mar26',
    cashback:'Flat 30% Cashback',
    bonus:'Flat ₹25 Bonus',

  },
  {
    name: "MamaEarth",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/mamaearth.png",
    link: 'cashkaro://stores/mama-earth-coupons-excl-offr-mar26',
    cashback:'Upto 18% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "mCaffeine",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/m-caffine.png",
    link: 'cashkaro://stores/mcaffeine-coupons-excl-offr-mar26',
    cashback:'Flat 15% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Oppo",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/oppo.png",
    link: 'cashkaro://stores/oppo-coupons-excl-offr-mar26',
    cashback:'Upto 3% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Foxtale",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/foxtale.png",
    link: 'cashkaro://stores/foxtale-coupons-excl-offr-mar26',
    cashback:'Upto 15% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Dot and Key",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/dot-and-key.png",
    link: 'cashkaro://stores/dotandkey-coupons-excl-offr-mar26',
    cashback:'Upto 15% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Clovia",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/clovia.png",
    link: 'cashkaro://stores/clovia-coupons-excl-offr-mar26',
    cashback:'Flat 12% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Hyphen",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/hyphen.png",
    link: 'cashkaro://stores/hyphen-coupon-codes-excl-offr-mar26',
    cashback:'Flat 12% Cashback'       ,
    bonus:'Flat ₹20 Bonus',

  },
  // {
  //   name: "BoAt",
  //   img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/boat.png",
  //   link: 'cashkaro://stores/boat-coupon-excl-offr-mar26',
  //   cashback:'Flat 5% Cashback',
  //   bonus:'Flat ₹20 Bonus',

  // },
  {
    name: "Decathlon",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/decathlon.png",
    link: 'cashkaro://stores/decathlon-coupon-excl-offr-mar26',
    cashback:'Flat 2.5% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "The Man Company",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/man-company.png",
    link: 'cashkaro://stores/themancompany-coupons-excl-offr-mar26',
    cashback:'Upto 15% Cashback',
    bonus:'Flat ₹20 Bonus',

  },
  {
    name: "Ajio",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/ajioo.png",
    link: 'cashkaro://stores/ajio-coupons-excl-offr-mar26',
    cashback:'Upto 8% Cashback',
    bonus:'Upto ₹75 Bonus',

  },
  {
    name: "Truemeds",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/netmed.png",
    link: 'cashkaro://stores/truemeds-coupon-code-excl-offr-mar26',
    cashback:'Upto ₹370 Cashback',
    bonus:'Flat ₹15 Bonus',

  },
  {
    name: "Realme",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/realme.png",
    link: 'cashkaro://stores/realme-offers-excl-offr-mar26',
    cashback:'Upto 5.5% Cashback',
    bonus:'Flat ₹15 Bonus',

  },
  {
    name: "Healthkart",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/healthkart.png",
    link: 'cashkaro://stores/healthkart-excl-offr-mar26',
    cashback:'Flat 3% Cashback',
    bonus:'Flat ₹15 Bonus',

  },
  {
    name: "Flipkart",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/flipkartm.png",
    link: 'cashkaro://stores/flipkart-excl-offr-mar26',
    cashback:'Upto 7% Cashback',
    bonus:'Upto ₹75 Bonus',

  },
  {
    name: "Amazon",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/amazonm.png",
    link: 'cashkaro://stores/amazon-excl-offr-mar26',
    cashback:'Upto 3.5% Rewards',
    bonus:'Upto ₹75 Bonus',

  },
  {
    name: "Myntra",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/myntram.png",
    link: 'cashkaro://stores/myntra-excl-offr-mar26',
    cashback:'Upto 6% Cashback',
    bonus:'Upto ₹75 Bonus',

  },
  {
    name: "Firstcry",
    img: "https://d2sriifpjiqv0p.cloudfront.net/mystery-box/first-cry.png",
    link: 'cashkaro://stores/firstcry-excl-offr-mar26',
    cashback:'Upto ₹35 Cashback',
    bonus:'Flat ₹10 Bonus',

  },
  
];


export default function MysteryBoxBonusNov() {

  const [alertOpen, setAlertOpen] = useState(true);
  const [message, setMessage] = useState();
  const [transaction, setTransaction] = useState(1);
  const [Reveal, setReveal] = useState(false);
  const [showGrid, setShowGrid] = useState(false);

  const bonus = localStorage.getItem('mb_bonus_march_new_cg') || 0;
  const bonus_added = localStorage.getItem('mb_bonus_added_march_new_cg') || 0;

  const navigate = useNavigate();

  // ✅ Guards to stop loops
  const hasRedirectedRef = useRef(false);
  const isFetchingRef = useRef(false);

  // ✅ Get CK ID (stable)
  const getCkId = () => {
    const params = new URLSearchParams(window.location.search);

    const ckIdFromUrl =
      params.get('userid') ||
      params.get('user_id') ||
      params.get('userId') ||
      params.get('ck_id') ||
      params.get('ckid');

    if (ckIdFromUrl) {
      localStorage.setItem('mb_ck_id_march_new_cg', ckIdFromUrl);
      return ckIdFromUrl;
    }

    return localStorage.getItem('mb_ck_id_march_new_cg');
  };

  const checkFunction = async () => {
    // ✅ Prevent multiple API calls
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;

    const ckId = getCkId();

    // ❌ No CK ID → redirect once only
    if (!ckId) {
      if (!hasRedirectedRef.current) {
        hasRedirectedRef.current = true;
        navigate('/mystery-box-march-new-cg/index', { replace: true });
      }
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SITE_URL_VP}/api/user/getuserdata_mb_mar?ck_id=${ckId}`
      );

      const data = await response.json();
      const userData = data?.user_data;

      // ✅ Store data safely
      if (userData?.bonus != null) {
        localStorage.setItem('mb_bonus_march_new_cg', userData.bonus);
      }

      if (userData?.bonus_added != null) {
        localStorage.setItem('mb_bonus_added_march_new_cg', userData.bonus_added);
      }

      if (userData?.claim != null) {
        localStorage.setItem('mb_open_march_new_cg', userData.claim);
      }

      const hasTransaction = (userData?.transactions_tag ?? 0) > 0;

      // ❌ No transaction → redirect once only
      if (!hasTransaction) {
        if (!hasRedirectedRef.current) {
          hasRedirectedRef.current = true;
          navigate('/mystery-box-march-new-cg/index', { replace: true });
        }
      }

    } catch (error) {
      console.error("API ERROR:", error);
      // ✅ Do NOT redirect on API failure (prevents loop)
    }
  };

  // ✅ Run only once per mount
  useEffect(() => {
    checkFunction();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleImageClick = () => {
    setReveal(true);
  };

  const showAlert = () => {
    setAlertOpen(true);
  };

  const closeAlert = () => {
    setAlertOpen(false);
  };
  return (
    <Grid container>
    <Grid item xs={12} sm={12} md={4} lg={4}></Grid>

    <Grid
      item
      xs={12}
      sm={12}
      md={4}
      lg={4}
      sx={{
        backgroundImage:
          "url(https://d2sriifpjiqv0p.cloudfront.net/mystery-box/bonusBG.png)",
        backgroundSize: "contain",
        backgroundPosition: "top center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#403326",
        position: "relative",
        overflow: "visible",
        minHeight: "100vh",
      }}
    >
      <Box sx={{ position: "relative", width: "100%" }}>

        {/* Logo */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Lottie
            animationData={MysteryLogo}
            loop
            autoplay
            style={{ width: "100%" }}
          />
        </div>

        {/* BONUS UI */}
        <div style={{ marginTop: "1rem", position: "relative", textAlign: "center" }}>
          <img
            src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/Popupp.png"
            alt="heading"
            style={{ width: "100%" }}
          />

          <Typography
            sx={{
              position: "absolute",
              top: "14%",
              left: "50%",
              transform: "translateX(-50%)",
              fontSize: "28px",
              fontWeight: 900,
              color: "#E8D7C3",
            }}
          >
            You <br /> got ₹{bonus}
          </Typography>

          <Typography
            sx={{
              position: "absolute",
              top: "40%",
              left: "50%",
              transform: "translateX(-50%)",
              fontSize: "13px",
              color: "#8D5B1C",
            }}
          >
            {bonus_added == 1
              ? "This Bonus Cashback has been added"
              : "You have claimed your Bonus Cashback"}
          </Typography>
        </div>

        {/* CTA */}
        <Box textAlign="center" mt={3}>
          <a href="cashkaro://my-earnings">
            <img
              src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/bonusCB.png"
              style={{ width: "80%" }}
              alt="cta"
            />
          </a>
        </Box>

        {/* DEAL GRID */}
        <Grid container spacing={2} px={2} pt={5}>
          {deals.map((item, index) => (
            <Grid item xs={4} key={index}>
              <Box textAlign="center">
                <img src={item.img} style={{ width: "100%" }} />
                <Typography fontSize="10px">{item.name}</Typography>
                <Typography fontSize="11px">{item.cashback}</Typography>
                <Typography fontSize="11px">+ {item.bonus}</Typography>

                <a href={item.link}>
                  <img
                    src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/shopNow.png"
                    style={{ width: "100%" }}
                  />
                </a>
              </Box>
            </Grid>
          ))}
        </Grid>

      </Box>

      <Faq />
    </Grid>

    <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
  </Grid>
  );
}
